(() => {
  const drawer = document.getElementById('ga-drawer');
  if (!drawer) return;

  const openBtns = document.querySelectorAll('[data-ga-drawer-open]');
  const closeBtns = drawer.querySelectorAll('[data-ga-drawer-close]');
  const panel = drawer.querySelector('.ga-drawer__panel');

  const open = () => {
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ga-drawer-open', 'ga-lock');
    document.body.classList.add('ga-lock');

    const closeBtn = drawer.querySelector('[data-ga-drawer-close]');
    if (closeBtn) closeBtn.focus();
  };

  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ga-drawer-open', 'ga-lock');
    document.body.classList.remove('ga-lock');
  };

  openBtns.forEach(btn => btn.addEventListener('click', open));
  closeBtns.forEach(btn => btn.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  drawer.addEventListener('click', (e) => {
    const isOpen = drawer.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;
    if (panel && !panel.contains(e.target) && !e.target.closest('[data-ga-drawer-open]')) close();
  });
})();
